const cloudinaryConfig = {
  cloudName: "dfinki0p4",
  presetName: "dfinki0p4",
};

export default cloudinaryConfig;
